import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import PlaceInputWrap from '../PlaceInputWrap';
import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import {errorInfoConfig} from '~/misc/error-info';
import {deleteGeosearchList} from '~/modules/geosearch/actions';
import {track} from '~/misc/metrics';
import {modalChange} from '~/modules/modal/actions';
import css from '../index.css';
import { removeQuery } from '~/misc/getQuery';
import deeplink from '~/misc/deeplink';
const openDeeplink = () => {
  const [isMobile] = removeQuery(['isMobile']);
  if(isMobile) {
    setTimeout(()=> {
      window.location.href = deeplink.openRateCheck({hash: isMobile});
    }, 0)
  }
} 
class RateCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        origin: '',
        destination: '',
        equipment: 'Flatbed',
      },
      formError: {},
    };
    this.changeEquip = this.changeEquip.bind(this);
    this.placeHandleChange = this.placeHandleChange.bind(this);
    this.placeHandleBlur = this.placeHandleBlur.bind(this);
    this.onSubM = this.onSubM.bind(this);
  }
  componentDidMount() {
    openDeeplink();
  }
  componentWillUnmount() {
    this.props.deleteGeosearchList('rate-origin');
    this.props.deleteGeosearchList('rate-destination');
  }

  render() {
    return (
      <div className={css.rateContent}>
        <div className={css.inputWrap}>
          <div className={css.left}>
            < PlaceInputWrap
              id='rate'
              onChange={(param) => this.placeHandleChange(param)}
              onBlur={(param) => this.placeHandleBlur(param)}
              formError = {this.state.formError}
            />
            <div className={css.equipWrap}>
              <div className={css.equipLabel}>EQUIPMENT</div>
              <div className={css.checkItemWrap}>
                <span
                  onClick={this.changeEquip}
                  className={cs(
                    css.item,
                    (!this.state.formData.equipment
                      || this.state.formData.equipment === 'Flatbed') && css.itemActive,
                    css.rightBorder)}
                >Flatbed</span>
                <span
                  onClick={this.changeEquip}
                  className={cs(
                    css.item,
                    (this.state.formData.equipment === 'Van') && css.itemActive,
                    css.rightBorder)}
                >Van</span>
                <span
                  onClick={this.changeEquip}
                  className={cs(css.item, (this.state.formData.equipment === 'Reefer') && css.itemActive)}
                >Reefer</span>
              </div>
            </div>
          </div>
        </div>
        <div className={css.btnWrap}>
          <Button onClick={this.onSubM} mods={['huge', 'wide', 'action']}>
            Check
          </Button>
        </div>
      </div>
    );
  }

  changeEquip(e) {
    this.setState({
      formData: Object.assign({}, this.state.formData, {equipment: e.currentTarget.innerHTML}),
    });
  }

  placeHandleChange(param) {
    this.setState({
      formData: Object.assign({}, this.state.formData, {[param.name]: param.data.placeValue}),
      formError: Object.assign({}, this.state.formError, {[param.name]: ''}),
    });
  }

  canClickOrNot(formData, formError) {
    let canNotClick = false;
    Object.keys(formData).forEach((key) => {
      if (key === 'origin' || key === 'destination') {
        if (isEmpty(formData[key])) {
          canNotClick = true;
          formError[key] = errorInfoConfig.placeInput.empty;
          return;
        }
        if (!formData[key].is_city) {
          canNotClick = true;
          formError[key] = errorInfoConfig.placeInput.wrong;
          return;
        }
      }
      if (!formData[key] || formError[key]) {
        canNotClick = true;
        formError[key] = formError[key] ? formError[key] : errorInfoConfig.text.empty;
        return;
      }
    });
    return {
      canNotClick,
      formError,
    };
  }

  onSubM() {
    const token = this.props.user.token;
    const {accountLevel, premium} = this.props.account;
    if (!token) {
      return this.props.login();
    }
    if (!(parseInt(accountLevel) >= parseInt(premium))) {
      return this.props.showUpgradeToPremium('rate check page');
    }
    const formData = this.state.formData;
    const formError = this.state.formError;
    const judgeClick = this.canClickOrNot(formData, formError);
    if (judgeClick.canNotClick) {
      return this.setState({
        formError: Object.assign({}, formError, judgeClick.formError),
      });
    }
    track('rate check in my loadboard', {
      'Pick up location': formData.origin,
      'Drop off location': formData.destination,
      'equipment': formData.fuelPrice,
    });
    return this.props.goToRate(formData);
  }

  placeHandleBlur(param) {
    let errorMsg = '';
    if (!param.data.placeValue || !param.data.placeValue.name || isEmpty(param.data.placeValue)) {
      errorMsg = errorInfoConfig.placeInput.empty;
    } else if (param.data.placeValue.name.indexOf(',') === -1 && !param.data.placeValue.is_city || param.data.placeValue.is_other) {
      errorMsg = errorInfoConfig.placeInput.wrong;
    }

    this.setState({
      formData: Object.assign({}, this.state.formData, {[param.name]: param.data.placeValue}),
      formError: Object.assign({}, this.state.formError, {[param.name]: errorMsg}),
    });
  }

}

export default connect(({user, routing, account}) => ({user, routing, account}), mapDispatch({
  deleteGeosearchList: (props, id) => deleteGeosearchList(id),
  showUpgradeToPremium: (props, source) => modalChange('pop', {
    source: source,
    type: 'pop_upgrade_to_premium',
  }),
}))(RateCheck);



// WEBPACK FOOTER //
// ./src/components/rate/AddressAndEqipInfo/RateCheck/index.js